import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-hub">
            <h3 className="footer-title">Nand Cash and Carry LTD</h3>
            <p className="footer-pitch">
              Your trusted wholesale partner since 2025, delivering bulk essentials from Welling, UK, at unbeatable prices.
            </p>
            <div className="newsletter">
              <input
                type="email"
                placeholder="Join our newsletter"
                aria-label="Email for newsletter"
              />
              <button>Subscribe</button>
            </div>
          </div>
          <div className="footer-contacts">
            <h4>Contact</h4>
            <div className="contact-item">
              <a href="tel:+447506003713" className="contact-info">
                07506003713
              </a>
            </div>
            <div className="contact-item">
              <a href="mailto:nandcashandcarry@gmail.com" className="contact-info">
                nandcashandcarry@gmail.com
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-info">
                77A Bellegrove Road, Welling, DA16 3PG
              </span>
            </div>
          </div>
          <div className="footer-nav">
            <h4>Explore</h4>
            <a href="#products" className="nav-link">
              Products
            </a>
            <a href="#about" className="nav-link">
              About
            </a>
            <a href="#contact" className="nav-link">
              Contact
            </a>
          </div>
        </div>
        <div className="footer-line">
          <p className="footer-signoff">
            © {currentYear} Nand Cash and Carry LTD. All Rights Reserved.
          </p>
        </div>
        <a href="#top" className="back-to-top">
          Back to Top
        </a>
      </div>
    </footer>
  );
};

export default Footer;